var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Field__Component" }, [
    _vm.value
      ? _c(
          "div",
          [
            _vm._t("default", [
              _c("router-link", { attrs: { to: "/drivers/" + _vm.value.Id } }, [
                _vm._v(" " + _vm._s(_vm.value && _vm.value.Name))
              ])
            ])
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }